import { useMemo, createRef } from "react";
import { useMatch } from "react-router";
import CnbLink from "@core/layouts/header/components/common/CnbLink";
import { useCnbConfig } from "@core/hooks/useCnbConfig";
import { cn } from "@core/utils/domUtil";

import HorizontalNavScroll from "@core/components/nav/HorizontalNavScroll";

export default function CnbMobile() {
  const isMainPage = !!useMatch("/");
  const { activeIndex, menuDepthMap } = useCnbConfig();

  const depth1Items = useMemo(() => [{ url: "/", name: "홈" }, ...(menuDepthMap?.depth1 ?? [])], [menuDepthMap?.depth1]);

  const depth1LiRefs = useMemo(() => depth1Items?.map(() => createRef<HTMLLIElement>()) || [], [depth1Items]);
  const depth2LiRefs = useMemo(() => menuDepthMap?.depth2?.map(() => createRef<HTMLLIElement>()) || [], [menuDepthMap?.depth2]);

  return (
    <>
      {/** depth1 */}
      <div className={cn("w-full overflow-x-auto border-t border-gray-100")}>
        <HorizontalNavScroll items={depth1Items} activeIndex={activeIndex?.[0]} liRefs={depth1LiRefs}>
          {depth1Items?.map((item, idx) => (
            <li key={item.name} ref={depth1LiRefs[idx]}>
              <CnbLink type="mobile" depth="depth1" data={item} isActive={isMainPage ? idx === 0 : idx === activeIndex?.[0] + 1} />
            </li>
          ))}
        </HorizontalNavScroll>
      </div>
      {/** depth2 */}
      {!isMainPage && (
        <div className="sticky top-0 right-0 left-0 z-50 border-b-[6px] border-gray-100 bg-white">
          <HorizontalNavScroll items={menuDepthMap?.depth2} activeIndex={activeIndex?.[1]} liRefs={depth2LiRefs}>
            {menuDepthMap?.depth2?.map((item, idx) => (
              <li key={item.name} ref={depth2LiRefs[idx]}>
                <CnbLink type="mobile" depth="depth2" data={item} isActive={idx === activeIndex?.[1]} />
              </li>
            ))}
          </HorizontalNavScroll>
        </div>
      )}
    </>
  );
}
